import styled from "styled-components";

const ElementContents = styled.div`
    width:100%;
    height:100%;
`;

export default ElementContents;